export default "__VITE_ASSET__3c7c331c__"